import React, { useState, useEffect, useRef } from 'react';
import UrlParse from 'url-parse';
import { withAlert } from 'react-alert';
import { compose } from 'redux';
import { Checkbox, Flex, Row, Col } from 'antd';
import _ from 'lodash';
import Loading from '../../../../components/loading';
import SaveButton from './Buttons/SaveButton';

const BookingGuidelinesView = props => {
	const { pageProps, getBookingGuidelines, onBookingGuidelinesViewSubmit, resetBookingGuidelinesMeta, location } = props;
	const { booking_guidelines, loading, loadingSubmit } = pageProps;

	const [acknowledge, setAcknowledge] = useState(false);

	useEffect(() => {
		getBookingGuidelines();
	}, [getBookingGuidelines]);

	const onChange = e => {
		setAcknowledge(e.target.checked);
	};

	// Functions
	const onSubmit = () => {
		onBookingGuidelinesViewSubmit();
	};

	if (loading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<Loading />
			</div>
		);
	}

	return (
		<React.Fragment>
			<Row
				type="flex"
				justify="center"
				align="middle"
				style={{ marginTop: 16 }}
			>
				<Col
					xl={18}
					lg={18}
					md={24}
					sm={24}
					xs={24}
				>
					<span style={{ fontSize: 20, marginBottom: 20 }}>Booking Guidelines</span>
				</Col>
			</Row>
			<Row
				type="flex"
				justify="center"
				align="middle"
				style={{ marginTop: 16 }}
			>
				<Col
					xl={18}
					lg={18}
					md={24}
					sm={24}
					xs={24}
				>
					<div
						style={{ overflowY: 'auto' }}
					>
						<div dangerouslySetInnerHTML={{ __html: booking_guidelines && booking_guidelines.guidelines }} />
					</div>
					<div>
						<Checkbox
							onChange={onChange}
							style={{ fontSize: '16px' }}
						></Checkbox>
						<span style={{ marginLeft: 15, fontWeight: 600 }}>I acknowledge that I have read and understand the important notes.</span>
					</div>
					<div style={{ marginTop: 26 }}>
						<Flex justify="end">
							<SaveButton
								label="Start Application"
								onClick={onSubmit}
								disabled={!acknowledge}
								loading={loadingSubmit}
							/>
						</Flex>
					</div>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default compose(withAlert())(BookingGuidelinesView);
